import * as React                          from 'react'
import { FormattedDate, FormattedMessage } from 'react-intl'

import Button       from '@material-ui/core/Button/Button'
import CardActions  from '@material-ui/core/CardActions'
import CardContent  from '@material-ui/core/CardContent'
import ListItem     from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ScheduleIcon from '@material-ui/icons/Schedule'
import TodayIcon    from '@material-ui/icons/Today'

import { canInteractWithProcess }          from '../../project-utils/permissions'
import testingHooks                        from '../../testing-hooks'
import { DateTimePicker, PermissionGuard } from '../atoms'
import SessionCompleteFormDialog           from '../forms/SessionCompleteFormDialog'
import withToggle                          from '../hocs/withToggle'

const CompleteSession = withToggle(
  ({
    onCompletionSubmit,
    activate,
    deactivate,
    isActive,
    sessionCompleteCommunication,
    ...rest
  }: any) => {
    return (
      <>
        <SessionCompleteFormDialog
          close={deactivate}
          isOpen={isActive}
          onSubmit={onCompletionSubmit}
          {...sessionCompleteCommunication}
          {...rest}
        />
        <Button
          data-test-id={testingHooks.buttons.confirmSessionCompletion}
          onClick={activate}
          color={'primary'}
        >
          <FormattedMessage id={'buttonActions.confirmCompletion'} />
        </Button>
      </>
    )
  }
)

const UpdateSession = withToggle(
  class extends React.Component<any> {
    public componentDidUpdate (lastProps) {
      if (
        lastProps.sessionUpdateCommunication.fetching
        && this.props.sessionUpdateCommunication.success
      ) {
        this.props.deactivate()
      }
    }

    public render () {
      const {
        onUpdateSubmit,
        date,
      } = this.props
      return (
        <DateTimePicker
          value={date}
          onChange={onUpdateSubmit}
          TextFieldComponent={(props: any) => (
            <Button color={'primary'} {...props}>
              <FormattedMessage id={'generic.updateSessionPrompt'} />
            </Button>
          )}
        />
      )
    }
  }
)

const SessionScheduled = ({
  session,
  onCompletionSubmit,
  onUpdateSubmit,
  sessionCompletionCommunication,
  sessionUpdateCommunication,
}: any) => {
  const phrasing = {
    na: <FormattedMessage id={'dictionary.na'} />,
  }

  const date = session.date
    ? (
      <FormattedDate
        value={session.date}
        year={'numeric'}
        month={'2-digit'}
        day={'2-digit'}
      />
    )
    : phrasing.na

  const time = session.date
    ? (
      <FormattedDate
        value={session.date}
        hour={'2-digit'}
        minute={'2-digit'}
      />
    )
    : phrasing.na

  return (
    <>
      <CardContent>
        <ListItem disableGutters>
          <TodayIcon color={'primary'} />
          <ListItemText primary={date} />
        </ListItem>
        <ListItem disableGutters>
          <ScheduleIcon color={'primary'} />
          <ListItemText primary={time} />
        </ListItem>
      </CardContent>

      <PermissionGuard check={canInteractWithProcess}>
        <CardActions>
          <CompleteSession
            sessionCompleteCommunication={sessionCompletionCommunication}
            onCompletionSubmit={onCompletionSubmit}
          />
          <UpdateSession
            sessionUpdateCommunication={sessionUpdateCommunication}
            onUpdateSubmit={onUpdateSubmit}
            date={session.date}
          />
        </CardActions>
      </PermissionGuard>
    </>
  )
}

export default SessionScheduled



// WEBPACK FOOTER //
// ./src/components/molecules/SessionScheduled.tsx